import React from "react"
import { Heading, VStack, Text } from "@chakra-ui/react"
import { Icon } from "../../"

export default function UspItem({ icon, heading, body }) {
  return (
    <VStack spacing={6} maxWidth="390px" mx="auto">
      <Icon name={icon} color="primary.200" boxSize="100px" />

      <Heading
        color="primary.200"
        fontSize="lg"
        textAlign="center"
        fontWeight="medium"
      >
        {heading}
      </Heading>
      <Text textAlign="center" mb="auto">
        {body}
      </Text>
    </VStack>
  )
}
